<div class="link" (click)="viewAllForms($event)">
  {{ formsLinkText }}
</div>

<app-modal [allowClose]="false" [(visible)]="isFormsModalVisible" header="Attestation Forms">
  <div class="forms-container">
    <div class="form-item" *ngFor="let form of forms; trackBy: trackByForm">
    <a class="file-link" (click)="downloadFile(form.documentPath)">{{ form.fileName }}</a>

    <app-button text="Delete" [disabled]="deleteLoading" (onClick)="deleteForm(form)">
      Delete
    </app-button>
  </div>
  </div>
  <footer>
    <app-button text="Upload Forms" (onClick)="this.uploadFormClicked.emit();"></app-button>
    <app-button classes="secondary" text="Cancel" (onClick)="onCancel()"></app-button>
  </footer>

</app-modal>